module.exports = __webpack_public_path__ + "img/芒果4.c5cbd65f.png";